exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ny-sidebar .el-menu--collapse .el-submenu__title span{display:none}.ny-sidebar .el-menu--collapse .el-submenu__title .el-submenu__icon-arrow{display:none}.ny-sidebar .el-menu--collapse{width:58px}.ny-sidebar .el-menu{border-right:none}.ny-sidebar .el-submenu__title{background-color:#fff !important;color:#000 !important;border-bottom:1px solid #ebecf1 !important;border-right:1px solid #fff !important}.ny-sidebar .el-menu{background-color:#fafafd}.ny-sidebar .el-menu-item{padding:0 20px 0 36px !important;border-bottom:1px solid #ebecf1}.ny-sidebar .el-menu>>>.el-submenu__icon-arrow{display:none}\n", ""]);

// exports
